<template>
  <div>
    <div class="row">
      <h4>API Key</h4>
      <div>
        <p>
          API Key helps you connect your store with e-commerce platforms to
          create and manage orders
        </p>
        <div class="copy-api-key">
          <CopyBanner :text="team.apiToken" @click="doCopy" />
        </div>
      </div>
    </div>

    <!-- Logout Button Here -->
    <div class="text-left">
      <button
        class="whitebutton-gemnote whitebutton-gemnote--small"
        @click="$store.dispatch('auth/logout')"
      >
        <span>Log out</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CopyBanner from '@/components/Universal/CopyBanner'

export default {
  name: 'APIKeyIntegration',
  components: { CopyBanner },

  computed: {
    ...mapState({
      team: state => state.team.team
    })
  },

  methods: {
    doCopy() {
      this.$copyText(this.team.apiToken).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`API Key copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Unable to copy API Key.`]
          })
          console.log(error)
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.row {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  height: 100%;
  padding: 2.5rem 3.5rem;
  background: inherit;
  border: 1px solid $onyx;
  margin-bottom: 2rem;
  border-radius: 29px;

  h4 {
    margin: 0.5rem 0;
    text-align: left;
    font-size: 1rem;
    color: $main-6;
    font-family: $editorial;
    font-weight: 400;
  }

  p {
    text-align: left;
    margin-bottom: 1.5rem;
    color: #232220;
    font-size: 0.813rem;
    font-weight: bold;
  }
}

.whitebutton-gemnote {
  padding: 0 1.75rem !important;
}

.copy-api-key {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: flex-start;
  max-width: 60%;
}
@media (max-width: 575.98px) {
  .row {
    padding: 2rem;
  }
}

@media (max-width: 850px) {
  .copy-api-key {
    max-width: 100%;
  }
}
</style>
